import * as Actions from '../actions';

const initialState = {
    currentModule: {
        module_id: 0,
        assetList: [],
        Active: 0,
        newModuleAssets: [],
        CreateAuthID: 0,
        LastEditAuthID: 0,
        CreationDate: '',
        LastEditDate: '',
        IsLocked: 0,
        LockedByAuthID: 0,
        labels: []
    },
    editInfo: {
        CreationDate: '',
        LastEditDate: '',
        CreateAuthEmail: '',
        LastEditAuthEmail: ''
    },
    isModuleLoaded: false,
    moduleList: [],
    listLoaded: false,
    moduleListLoadedAfterSave: true,
    moduleListSearchable: {
        companies: [],
        labels: []
    },
    allCourses: [],
    allLessons: [],
    currentModuleCourseList: [],
    currentModuleLessonList: [],
    scheduleWeeksNeeded: 0,
    deleteAllowed: false,
    module_on_calendar: [],
    companies: [],
    allCompanies: [],
    companySearch: ''
}

const moduleReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.UPDATE_MODULE_LOADED):
            {
                if (action.payload) {
                    return {
                        ...state,
                        isModuleLoaded: action.payload,
                    }
                } else {
                    // reset to default state
                    return {
                        ...initialState
                    }
                }
            }
        case (Actions.ACTIVATE_MODULE):
            {
                return {
                    ...state,
                    currentModule: {
                        ...state.currentModule,
                        Active: 1
                    }
                }
            }
        case (Actions.GET_MODULE):
            {
                return {
                    ...state,
                    currentModule: {
                        ...state.currentModule,
                        ...action.payload,
                        module_loaded: true
                    },
                };
            }

        case (Actions.GET_MODULE_ASSET_LIST):
            {
                const m_id = state.currentModule.module_id

                if (m_id === 0) {
                    const newAssetList = state.currentModule.newModuleAssets.concat(action.payload.assetInsertResponse);
                    const new_asset_ids = newAssetList.map(a => a.insert_id);
                    const filtered_assets = action.payload.responseData.filter(a => new_asset_ids.includes(a.header.asset_id));

                    return {
                        ...state,
                        currentModule: {
                            ...state.currentModule,
                            assetList: filtered_assets,
                            newModuleAssets: state.currentModule.newModuleAssets.concat(action.payload.assetInsertResponse)
                        }
                    }
                }
                else {
                    return {
                        ...state,
                        currentModule: {
                            ...state.currentModule,
                            assetList: action.payload.responseData,
                            newModuleAssets: []
                        }
                    }
                }

            }
        case (Actions.GET_RELATED_DATA):
            return {
                ...state,
                currentModuleCourseList: action.payload.courses,
                currentModuleLessonList: action.payload.lessons,
                editInfo: action.payload.edit_info,
                deleteAllowed: action.payload.deleteAllowed,
                module_on_calendar: action.payload.module_on_calendar,
                companies: action.payload.companies,
                allCompanies: action.payload.allCompanies
            }

        case (Actions.GET_COMPANY_LIST):
            {
                return {
                    ...state,
                    allCompanies: action.payload.map(c => {
                        return {
                            ...c,
                            label: c.CompanyName,
                            id: c.company_id
                        }
                    })
                }
            }
        case (Actions.TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((c) => c.id === action.payload.company.id)
                    return {
                        ...state,
                        companies: state.companies.concat(newCompany)
                    }
                }
                else {
                    return {
                        ...state,
                        companies: state.companies.filter((c) => c.id !== action.payload.company.id)
                    }
                }
            }
        case (Actions.COMPANY_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    companySearch: action.payload
                }
            }
        case (Actions.GET_SCHEDULED_LESSONS):
            {
                return {
                    ...state,
                    scheduleWeeksNeeded: action.payload.length > 0 ? action.payload[action.payload.length - 1].WeekNum : 1
                }
            }
        case (Actions.UPDATE_MODULE_FORM):
            {
                return {
                    ...state,
                    currentModule: { ...state.currentModule, ...action.payload }
                }
            }
        case (Actions.DELETE_MODULE):
            {
                return {
                    ...state,
                    currentModule: { module_loaded: false },
                    moduleList: state.moduleList.filter((module) => module.module_id !== action.payload)
                };
            }
        case (Actions.GET_MODULE_LIST):
            {
                return {
                    ...state,
                    moduleList: action.payload.moduleList.moduleList,
                    moduleListSearchable: {
                        companies: action.payload.moduleList.searchData.companies,
                        labels: action.payload.moduleList.searchData.labels
                    },
                    moduleListLoadedAfterSave: action.payload.call_location === 'list' ? state.moduleListLoadedAfterSave : true,
                    listLoaded: true
                };
            }
        case (Actions.UPDATE_MODULE_LIST_LOADED):
            {
                return {
                    ...state,
                    moduleListLoadedAfterSave: action.payload
                }
            }
        case (Actions.GET_ALL_LESSONS):
            {
                return {
                    ...state,
                    allLessons: action.payload.lessonList
                }
            }
        case (Actions.TOGGLE_COURSE):
            {
                if (action.payload.action_type === 'ADD') {
                    const newCourse = state.allCourses.filter((course) => course.course_id === action.payload.course.id)
                    return {
                        ...state,
                        currentModuleCourseList: state.currentModuleCourseList.concat(newCourse)
                    }
                }
                else {
                    return {
                        ...state,
                        currentModuleCourseList: state.currentModuleCourseList.filter((course) => course.course_id !== action.payload.course.id)
                    }
                }
            }
        case (Actions.TOGGLE_LESSON):
            {
                if (action.payload.action_type === 'ADD') {
                    const newLesson = state.allLessons.filter((lesson) => lesson.lesson_id === action.payload.lesson.id)
                    return {
                        ...state,
                        currentModuleLessonList: state.currentModuleLessonList.concat(newLesson)
                    }
                }
                else {
                    return {
                        ...state,
                        currentModuleLessonList: state.currentModuleLessonList.filter((lesson) => lesson.lesson_id !== action.payload.lesson.id)
                    }
                }
            }
        case (Actions.CHANGE_SCHEDULE_WEEKS_NEEDED):
            {
                if (action.payload === 'UP') {
                    return {
                        ...state,
                        scheduleWeeksNeeded: state.scheduleWeeksNeeded + 1
                    }
                }
                return {
                    ...state,
                    scheduleWeeksNeeded: state.scheduleWeeksNeeded - 1
                }
            }
        case (Actions.DROP_ITEM_TO_DAY):
            // let checkIfSameLesson = state.currentModuleLessonList.filter((lesson) => lesson.lesson_id === action.payload.lesson.lesson_id && lesson.WeekNum === action.payload.week && lesson.DayOfWeek === action.payload.day)
            // if (checkIfSameLesson.length > 0) {
            //     return {
            //         ...state
            //     }
            // }
            const alreadyRelated = state.currentModuleLessonList.filter((lesson) => lesson.lesson_id === action.payload.lesson.lesson_id)
            /** Check if the lesson is already on the week board */
            if (alreadyRelated.length > 0) {
                return {
                    ...state,
                    currentModuleLessonList: state.currentModuleLessonList.map((lesson) => {
                        /** If an item is on the target drop, change its location to the drag origin */
                        if (lesson.WeekNum === action.payload.week && lesson.DayOfWeek === action.payload.day) {
                            return {
                                ...lesson,
                                WeekNum: action.payload.lesson.WeekNum,
                                DayOfWeek: action.payload.lesson.DayOfWeek,
                                DisplayOrder: action.payload.dayValue
                            }
                        }
                        if (lesson.lesson_id === action.payload.lesson.lesson_id) {
                            return {
                                ...lesson,
                                WeekNum: action.payload.week,
                                DayOfWeek: action.payload.day,
                                DisplayOrder: action.payload.dayValue
                            }
                        }
                        return lesson
                    })

                }
            }
            /** if the lesson isnt on the week board, create a new module_lesson_rel object */
            else {
                /** Check if there is another lesson on the target square */
                const checkTargetSquare = state.currentModuleLessonList.filter((lesson) => lesson.WeekNum === action.payload.week && lesson.DayOfWeek === action.payload.day)
                if (checkTargetSquare.length > 0 && !action.payload.lesson.DayOfWeek) {
                    return {
                        ...state,

                    }
                }
                const newModuleLesson = {
                    Active: 1,
                    DayOfWeek: action.payload.day,
                    DisplayOrder: action.payload.dayValue,
                    LessonDescription: action.payload.lesson.LessonDescription,
                    LessonName: action.payload.lesson.LessonName,
                    WeekNum: action.payload.week,
                    lesson_id: action.payload.lesson.lesson_id,
                    module_id: action.payload.module_id,
                    module_lesson_rel_id: 'new_' + action.payload.lesson.lesson_id
                }

                return {
                    ...state,
                    currentModuleLessonList: state.currentModuleLessonList.concat(newModuleLesson)
                }

            }

        case (Actions.REMOVE_MODULE_LESSON_RELATION):
            {
                return {
                    ...state,
                    currentModuleLessonList: state.currentModuleLessonList.filter((lesson) => lesson.lesson_id !== action.payload)
                }
            }

        case (Actions.LOCK_MODULE):
            {
                return {
                    ...state,
                    currentModule: {
                        ...state.currentModule,
                        IsLocked: 1,
                        LockedByAuthID: action.payload
                    }
                }
            }

        case (Actions.UNLOCK_MODULE):
            {
                return {
                    ...state,
                    currentModule: {
                        ...state.currentModule,
                        IsLocked: 0,
                        LockedByAuthID: 0
                    }
                }
            }
        case (Actions.UPDATE_ASSET_NAME):
            {
                return {
                    ...state,
                    currentModule: {
                        ...state.currentModule,
                        assetList: state.currentModule.assetList.map(asset => {
                            if (asset.header.asset_id === action.payload.asset_id) {
                                return {
                                    ...asset,
                                    header: {
                                        ...asset.header,
                                        AssetNewName: action.payload.newName,
                                        UneditedNewName: action.payload.saved ? action.payload.newName : asset.header.UneditedNewName
                                    }
                                }
                            }
                            return asset
                        })
                    }
                }
            }
        default:
            {
                return state;
            }
    }
}

export default moduleReducer;


// WEBPACK FOOTER //
// src/main/content/module/store/reducers/module.reducer.js